'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

function getDateInstance(data) {
  if (typeof data === "string") {
    return parsers.isoDatePartToDate(data);
  } else if (typeof data === "number") {
    return new Date(data);
  } else {
    return data;
  }
}
function getDateRangeDayCount(from, to) {
  const fromDate = getDateInstance(from);
  const toDate = getDateInstance(to);
  return dateFns.eachDayOfInterval({
    start: fromDate,
    end: toDate
  }).length;
}

module.exports = getDateRangeDayCount;
//# sourceMappingURL=getDateRangeDayCount.cjs.map
